import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';

export default class SfsPageTitle extends Helper {
  @service intl;

  default = `${this.intl.t('sfs.pageTitle.default')}`;

  compute([title]) {
    if (this.intl.t(title)) {
      document.title = `${this.intl.t(title)} | ${this.default}`;
    } else {
      document.title = this.default;
    }
  }
}
